"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aliasResolver = aliasResolver;
exports.defaultNamespaceResolver = defaultNamespaceResolver;
const enums_1 = require("@aurora/shared-types/pages/enums");
const ObjectHelper_1 = require("@aurora/shared-utils/helpers/objects/ObjectHelper");
const endUserModuleRegistry_1 = require("../../features/endUserModuleRegistry");
const ComponentAliasResolver_1 = __importDefault(require("@aurora/shared-client/helpers/components/ComponentAliasResolver"));
const customPageModulePath = (0, endUserModuleRegistry_1.getModulePathForComponent)(enums_1.EndUserComponent.CUSTOM_PAGE);
/**
 * returns namespace for the given alias. If not found then null is returned.
 * @param alias
 */
function aliasResolver(alias) {
    const componentId = (0, ObjectHelper_1.enumFromValue)(enums_1.EndUserComponent, alias);
    if (componentId) {
        return (0, endUserModuleRegistry_1.getModulePathForComponent)(componentId);
    }
    else {
        if (alias.startsWith(enums_1.EndUserComponent.CUSTOM_PAGE)) {
            const [, pageId] = alias.split(enums_1.EndUserComponent.CUSTOM_PAGE + '.');
            return (0, endUserModuleRegistry_1.getModulePathForComponent)(enums_1.EndUserComponent.CUSTOM_PAGE, pageId);
        }
        else {
            return (0, ComponentAliasResolver_1.default)(alias);
        }
    }
}
function defaultNamespaceResolver(namespace) {
    if (namespace.startsWith(customPageModulePath)) {
        return customPageModulePath;
    }
    return namespace;
}
//# sourceMappingURL=NamespaceResolverHelper.js.map